import { PAGE_CONFIG } from '../../constants/pages';
import FlexRow from '../shared/FlexRow';

export default function Menu({ changePage, currentPage }) {
  const pages = PAGE_CONFIG.map((page) => page.name);
  return (
    <FlexRow expand={styles.container}>
      {pages.map((page) => (
        <div
          style={currentPage == page ? styles.pageClicked : styles.page}
          key={`menu-page-name-${page}`}
          onClick={() => changePage(page)}
        >
          {page}
        </div>
      ))}
    </FlexRow>
  );
}

const styles = {
  page: {
    margin: 10,
    cursor: 'pointer',
    fontWeight: '500',
    fontSize: 20,
    padding: 20,
  },
  pageClicked: {
    margin: 10,
    cursor: 'pointer',
    fontWeight: 'bold',
    fontSize: 20,
    padding: 20,
  },
};
